<template>
    <v-container style="margin: 60px 10%" fluid>
      <vueHeadful
      :title="this.$i18n.t('Menu.Club') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
      <v-row>
        <v-col cols="12" align="center" style="margin-bottom:40px">
          <h1 :style="responsiveTitulo + 'margin-bottom:60px'" class="titulo">{{$t('Club.Club')}}</h1>
        </v-col>
        <v-col cols="12" xs="12" md="6" align-self="center" style="margin-bottom: 40px">
          <v-img :src="i.imagen" contain />
        </v-col>
        <v-col cols="12" xs="12" md="6" style="padding-left: 5%;margin-bottom: 40px" align-self="center">
          <div id="club" v-html="i.textoEs" v-if="getIdioma === 'es'" />
          <div id="club" v-html="i.textoEn" v-else />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { mapGetters } from 'vuex'
export default {
  name: 'Club',
  data () {
    return {
      i: null
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('club').get().then(info => {
      this.i = info.data()
    })
  },
  computed: {
    ...mapGetters(['getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>

<style>
div#club .ql-align-center, div#club .ql-align-justify {
  font-weight: 400;
}

</style>
